export const PROPERTY_EVENT_DICTIONARY = [
  {
    options: "event_category_ext",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "event_category_ext",
    entitySpec: "data",
  },
  {
    options: "event_type_ext_name",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "event_type_ext_name",
    entitySpec: "ref",
  },
  {
    options: "condition",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "condition",
    entitySpec: "ref",
  },
  {
    options: "event_group",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "event_group",
    entitySpec: "ref",
  },
];

export const PROPERTY_EVENT_COLUMNS = [
  {
    header: "ID",
    field: "event_type_ext_id",
    bodyStyle: "text-align: right; width:65px;",
    editor: {
      name: "InputText",
      style: (value) => {
        if (value < 0) return { color: "white" };
        return null;
      },
      attrList: {
        disabled: true,
      },
    },
  },
  {
    header: "Категория",
    field: "event_category_ext_name",
    loadOptions: "event_category_ext",
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "event_category_ext_name",
        options: [],
        optionLabel: "event_category_ext_name",
        optionValue: "event_category_ext_name",
        placeholder: "...",
        appendTo: "body",
        filter: true
      },
    },
  },
  {
    header: "Категория(name)",
    field: "event_category_ext_name",
    visible: false,
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Описание события",
    field: "event_type_ext_name",
    loadOptions: "event_type_ext_name",
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "event_type_ext_name",
        options: [],
        optionLabel: "event_type_ext_name",
        optionValue: "event_type_ext_name",
        placeholder: "...",
        appendTo: "body",
        filter: true
      },
    },
  },
  {
    header: "Описание события(name)",
    field: "event_type_ext_name",
    visible: false,
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Тип сравнения",
    field: "condition_code",
    loadOptions: "condition",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "condition_name",
        optionValue: "condition_code",
        placeholder: "...",
        appendTo: "body",
      },
    },
  },
  {
    header: "Значениче № бита",
    field: "property_value",
    bodyStyle: "text-align: right;",
    editor: {
      name: "InputNumber",
    },
  },
  {
    header: "Группа",
    field: "event_group_id",
    dataType: "dropdown",
    loadOptions: "event_group",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "event_group_name",
        optionValue: "event_group_id",
        placeholder: "...",
        appendTo: "body",
      },
    },
  },
  {
    header: "Звук",
    field: "sound_enabled",
    bodyStyle: "text-align: center;",
    dataType: "component",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: {
      name: "checkbox",
      attrList: {
        binary: true,
      },
    },
  },
];
export const PROPERTY_TYPE_CONVERSION_DICTIONARY = [
  {
    options: "event_group",
    save: { store: false, self: true },
    load: "db",
    serviceName: "BaseService",
    entityName: "event_group",
    entitySpec: "ref",
  },
];
export const PROPERTY_TYPE_CONVERSION_COLUMNS = [
  {
    header: "ID",
    field: "property_type_conversion_id",
    visible: false,
    bodyStyle: "text-align: right",
  },
  {
    header: "Расчетное значение",
    field: "property_outvalue",
    bodyStyle: "text-align: right",
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Текстовая интерпретация",
    field: "property_outvalue_text",
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Состояние",
    field: "event_group_id",
    dataType: "dropdown",
    loadOptions: "event_group",
    editor: {
      name: "Dropdown",
      attrList: {
        options: [],
        optionLabel: "event_group_name",
        optionValue: "event_group_id",
        placeholder: "",
        appendTo: "body",
      },
    },
  },
];
export const PROPERTY_TYPE_DATA_DICTIONARY = [{
  options: "class",
  save: { store: false, self: true },
  load: "db",
  serviceName: "BaseService",
  entityName: "property_type_class",
  entitySpec: "ref",
},
{
  options: "unit",
  save: { store: false, self: true },
  load: "db",
  serviceName: "BaseService",
  entityName: "unit",
  entitySpec: "ref",
},];
export const PROPERTY_TYPE_DATA_COLUMNS = [
  {
    header: "ID",
    field: "property_type_id",
    sortable: true,
    bodyStyle: "text-align: right;",
    visible: false,
  },
  {
    header: "Тип",
    field: "property_type_ref",
    bodyStyle: "overflow: hidden",
    tooltip: "property_type_name",
    sortable: true,
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "property_type_ref",
        options: [
          { id: 0, property_type_ref: "Пользовательский" },
          { id: 1, property_type_ref: "Справочник" },
        ],
        optionLabel: "property_type_ref",
        optionValue: "id",
        showClear: true,
        placeholder: "...",
        appendTo: "body",
      },
    },
  },
  {
    header: "Название",
    field: "property_type_name",
    bodyStyle: "overflow: hidden",
    tooltip: "property_type_name",
    sortable: true,
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Системное название",
    field: "property_type_sysname",
    tooltip: "property_type_sysname",
    bodyStyle: "overflow: hidden",
    sortable: true,
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Класс",
    field: "property_type_class",
    tooltip: "property_type_class",
    bodyStyle: "overflow: hidden",
    sortable: true,
    loadOptions: "class",
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "property_type_class",
        options: [],
        optionLabel: "property_type_class",
        optionValue: "property_type_class",
        showClear: true,
        filter: true,
        placeholder: "...",
        appendTo: "body",
      },
    },
  },
  {
    header: "Кр. назв.",
    field: "property_type_sname",
    sortable: true,
    editor: {
      name: "InputText",
    },
  },
  {
    header: "Цвет (тренд)",
    field: "property_type_color",
    sortable: true,
    dataType: "component",
    configComponents: [
      {
        name: "ColorPicker",
        attrList: { disabled: true },
      },
    ],
    editor: {
      name: "ColorPicker",
    },
  },
  {
    header: "Маска катег.",
    field: "event_category_mask",
    sortable: true,
    bodyStyle: "text-align: right;",
    visible: false,
    editor: {
      name: "InputNumber",
      attrList: {
        mode: "decimal",
        minFractionDigits: 0,
      },
    },
  },
  {
    header: "Ед изм",
    field: "unit_mask_id",
    sortable: true,
    loadOptions: "unit",
    dataType: "dropdown",
    editor: {
      name: "Dropdown",
      attrList: {
        "v-model": "unit_mask_id",
        options: [],
        optionLabel: "unit_sname",
        optionValue: "unit_mask_id",
        showClear: true,
        placeholder: "...",
        appendTo: "body",
      },
    },
  },
  {
    header: "Период сохр, сек",
    field: "property_type_save_rate",
    bodyStyle: "text-align: right;",
    sortable: true,
    editor: {
      name: "InputNumber",
      attrList: {
        mode: "decimal",
        minFractionDigits: 0,
      },
    },
  },
  {
    header: "Непрер.",
    field: "property_type_is_fast",
    sortable: true,
    dataType: "component",
    bodyStyle: "text-align: center;",
    visible: false,
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: {
      name: "checkbox",
      attrList: {
        binary: true,
      },
    },
  },
  {
    header: "Отобр в форме",
    field: "property_type_is_visible_form",
    sortable: true,
    dataType: "component",
    bodyStyle: "text-align: center;",
    configComponents: [
      {
        name: "checkbox",
        attrList: {
          binary: true,
          disabled: true,
        },
      },
    ],
    editor: {
      name: "checkbox",
      attrList: {
        binary: true,
      },
    },
  },];